import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/material';
import CaregiverTrustSafetyStep from '../components/CaregiverTrustSafetyStep';

// FEAT-061 — Caregiver Trust & Safety onboarding page (web).
// MVP-8.20 … MVP-8.27. Mounted at /caregiver-trust-safety — see
// AppNavigator. Thin wrapper around the step component; on completion the
// caregiver is returned to their profile management surface.

const CaregiverTrustSafetyPage: React.FC = () => {
  const navigate = useNavigate();

  const handleComplete = () => {
    navigate('/caregiver-profile-management');
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }} data-testid="caregiver-trust-safety-page">
      <CaregiverTrustSafetyStep onComplete={handleComplete} />
    </Container>
  );
};

export default CaregiverTrustSafetyPage;
